module.exports = __webpack_public_path__ + "static/media/nerdUnlocked.4adf8fab.png";